
export type Language = 'de' | 'en';

export const translations = {
  de: {
    title: "Streckenfliegen.app",
    subtitle: "Plane Smarter · Fliege Weiter",
    nav: {
      terrain: "Karte",
      analyst: "Streckenplanung",

      advisor: "KI-Chat",
      library: "Strecken",
      profile: "Mein Profil"
    },
    status: "METEO-STATUS",
    meteoOnline: "SYSTEM LIVE",
    telemetry: "Konfiguration",
    mapTools: {
      move: "Verschieben",
      add: "Hinzufügen",
      delete: "Löschen",
      hint: "Linie: Punkt einfügen | Rechtsklick: Löschen | Ziehen: Bewegen"
    },
    airspaces: {
      title: "Luftraum-Filter",
      ctr: "CTR / Kontrollzonen",
      tma: "TMA / Nahkontrollbereiche",
      glider: "Wildschutzgebiete",
      restricted: "R / D / P (Beschränkt)",
      obstacles: "Kabel & Hindernisse"
    },
    profile: {
      title: "Pilot & Ausrüstung",
      desc: "Grundlage für die taktische Reichweitenberechnung.",
      aeroSection: "Performance-Daten",
      gliderModel: "Modell",
      certClass: "EN-Klasse",
      measuredLD: "Gleitzahl",
      pilotSection: "Piloten-Setup",
      harnessModel: "Gurtzeug",
      harnessGeom: "Gurtzeug-Typ",
      totalWeight: "Gewicht (Kg)",
      skillSection: "Skills & Bestleistungen",
      skillLevel: "Skill-Level (1-10)",
      skillDesc1: "Frisch von der Prüfung",
      skillDesc10: "Weltspitze / PWC",
      maxDist: "Weiteste Strecke (km)",
      maxFai: "Grösstes FAI (km)",
      noteTitle: "Strategie-Hinweis:",
      noteText: "Genaue Gleitzahlen und Skill-Angaben sind essenziell für präzise Grat-Sprung Berechnungen."
    },
    planner: {
      title: "Routen-Optimierung",
      date: "Flugtag",
      launch: "Startplatz",
      suggestLaunch: "Autonome Spot-Suche (KI)",
      suggesting: "Meteo-Audit: Previtemp & XContest...",
      btn: "Grat-Tracing XC-Route berechnen",
      loading: "Berechne optimales Terrain-Following...",
      briefing: "Meteo & Taktik-Briefing",
      sources: "Verifizierte Wetterdaten",
      modes: {
        fai: "FAI",
        flat: "FLACH",
        free: "FREI",
        egal: "EGAL"
      }
    },
    advisor: {
      title: "Strategie-Berater",
      welcomeMessages: [
        "Hallo! 👋 Wie kann ich dir heute helfen? Ob Streckenplanung, Wetteranalyse oder Flugtaktik – frag mich einfach!",
        "Grüezi! 🏔️ Bereit für dein nächstes Flugabenteuer? Ich helfe dir gerne bei der Planung.",
        "Hey Pilot! ✈️ Was steht heute auf dem Programm? Ich bin bereit für deine Fragen rund ums Streckenfliegen.",
        "Willkommen! 🎯 Brauchst du Hilfe bei einer Route, einem Wetterbriefing oder einer Fluganalyse? Ich bin für dich da!",
        "Servus! 🪂 Schön dich zu sehen. Wie kann ich dir beim Streckenflug weiterhelfen?"
      ],
      placeholder: "Frage zu Basis, Talwind oder Grat-Effizienz...",
      loading: "Konsultiere Modelle..."
    }
  },
  en: {
    title: "Streckenfliegen.app",
    subtitle: "Plane Smarter · Fliege Weiter",
    nav: {
      terrain: "Map",
      analyst: "Strategy",

      advisor: "AI Chat",
      library: "Tracks",
      profile: "My Profile"
    },
    status: "METEO STATUS",
    meteoOnline: "SYSTEM LIVE",
    telemetry: "Configuration",
    mapTools: {
      move: "Move",
      add: "Add Point",
      delete: "Delete Point",
      hint: "Line: Add Point | Right-Click: Delete | Drag: Move"
    },
    airspaces: {
      title: "Airspace Filters",
      ctr: "CTR / Control Zones",
      tma: "TMA / Terminal Areas",
      glider: "Wildlife Protection",
      restricted: "R / D / P (Restricted)",
      obstacles: "Cables & Obstacles"
    },
    profile: {
      title: "Pilot & Gear",
      desc: "Baseline for tactical reach calculation.",
      aeroSection: "Performance Data",
      gliderModel: "Model",
      certClass: "Certification",
      measuredLD: "L/D Ratio",
      pilotSection: "Pilot Setup",
      harnessModel: "Harness",
      harnessGeom: "Type",
      totalWeight: "Weight (Kg)",
      skillSection: "Skills & Records",
      skillLevel: "Skill Level (1-10)",
      skillDesc1: "New Pilot",
      skillDesc10: "World Class / PWC",
      maxDist: "Longest Flight (km)",
      maxFai: "Biggest FAI (km)",
      noteTitle: "Strategy Note:",
      noteText: "Accurate L/D ratio and skill metrics are critical for calculating ridge transitions."
    },
    planner: {
      title: "Route Optimization",
      date: "Flight Day",
      launch: "Launch Site",
      suggestLaunch: "Autonomous Spot Search (AI)",
      suggesting: "Meteo Audit: Skew-T & XContest...",
      btn: "Calculate Ridge-Tracing Route",
      loading: "Calculating terrain-following path...",
      briefing: "Meteo & Tactics Briefing",
      sources: "Verified Weather Data",
      modes: {
        fai: "FAI",
        flat: "FLAT",
        free: "FREE",
        egal: "AUTO"
      }
    },
    advisor: {
      title: "Strategy Advisor",
      welcomeMessages: [
        "Hello! 👋 How can I help you today? Whether route planning, weather analysis or flight tactics – just ask!",
        "Hi Pilot! 🏔️ Ready for your next flying adventure? I'm happy to help with planning.",
        "Hey there! ✈️ What's on the agenda today? I'm ready for your XC questions.",
        "Welcome! 🎯 Need help with a route, weather briefing or flight analysis? I'm here for you!",
        "Hi! 🪂 Great to see you. How can I help you with cross-country flying today?"
      ],
      placeholder: "Ask about base, valley winds, or ridge efficiency...",
      loading: "Consulting models..."
    }
  }
};
